/**
 * 公共参数存储类
 */
export default class Store {
  constructor() {
    this.info = {};
  }

  // 设置键值对
  setKV(key, value) {
    this.info[key] = value;
  }

  // 获取键值对
  getKV(key) {
    return this.info[key];
  }

  // 重置
  reset() {
    this.info = {};
  }

  // 删除指定建
  deleteKey(key) {
    if (this.info.hasOwnProperty(key)) {
      delete this.info[key];
    }
  }
}
